import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=7e1a7d96"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e1a7d96')) {
      api.createRecord('7e1a7d96', component.options)
    } else {
      api.reload('7e1a7d96', component.options)
    }
    module.hot.accept("./Feedback.vue?vue&type=template&id=7e1a7d96", function () {
      api.rerender('7e1a7d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Feedback.vue"
export default component.exports